import {
  SearchFlightState,
  searchFlightStore,
} from "@/core/stores/searchflight.store";
import { Component, Element, h, State } from "@stencil/core";
import {
  MULTIPLE_CONTENT,
  NOT_FOUND,
} from "@/core/services/search.service.responses";
import { ModalBox } from "@/components/internal/modal/modal-box";
import { theme } from "@/utils/theme";

@Component({
  tag: "pace-message-box",
  styleUrl: "message-box.scss",
  shadow: true,
})
export class MessageBoxComponent {
  @State() searchFlights: SearchFlightState;

  @Element() el: HTMLElement;

  componentWillLoad() {
    searchFlightStore.subscribe((searchFlights) => {
      this.searchFlights = { ...searchFlights };
    });
  }
  requiresAdvanceSearch() {
    const advanceSearchCodes = [
      MULTIPLE_CONTENT.statusCode,
      NOT_FOUND.statusCode,
    ];
    return advanceSearchCodes.includes(this.searchFlights.error.statusCode);
  }

  render() {
    if (this.searchFlights.error) {
      // this.searchFlights.error.message
      const basicSearch = this.searchFlights.searchFlight.basicSearch,
        actionPayload = {
          basicSearch: basicSearch && !this.requiresAdvanceSearch(),
        };

      return (
        <div class={"modal-container"}>
          <div class={"modal-container__wrapper"}></div>
          <div
            class={"modal-container__content"}
            style={theme.getContentStyle()}
          >
            <ModalBox
              message={this.searchFlights.error.message}
              payload={actionPayload}
            ></ModalBox>
          </div>
        </div>
      );
    }
  }
}
